import React from "react"
import { graphql } from "gatsby"
import { Container, Row, Col } from "reactstrap"
import { compose, prop } from "ramda"
import { getMarkdownEdges, getQueryData, getSectionDataFor } from "@utils/utils"

/**
 * import Sections
 */
import MainLayout from "@layouts/MainLayout/MainLayout"
import SEO from "@components/shared/SEO/SEO"

/**
 * quering data
 */

export const query = graphql`
  query ImpressumQuery {
    allMarkdownRemark(
      filter: {
        frontmatter: {
          path: { eq: "/impressum" }
          published: { eq: true }
          lang: { eq: "de" }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            path
            subtitle
            title
            section
          }
          internal {
            content
          }
          html
        }
      }
    }
  }
`

const Impressum = ({ data }) => {
  const content = compose(getQueryData, getMarkdownEdges)(data)
  const legalSectionData = getSectionDataFor("impressum-legal", content)
  const contactSectionData = getSectionDataFor("impressum-contact", content)

  const legalDetailsHtml = {
    __html: prop("html", legalSectionData),
  }
  const contactDetailsHtml = {
    __html: prop("html", contactSectionData),
  }

  return (
    <MainLayout>
      <SEO />
      <section className="impressum d-flex bg-light">
        <Container className="my-2 py-5">
          <Row className="my-5 d-flex justify-content-center small">
            <Col
              xs={11}
              sm={12}
              lg={10}
              xl={9}
              dangerouslySetInnerHTML={contactDetailsHtml}
            ></Col>
            <Col
              xs={11}
              sm={12}
              lg={10}
              xl={9}
              dangerouslySetInnerHTML={legalDetailsHtml}
            ></Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  )
}

export default Impressum
